import { transient, autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";

@autoinject
@transient()
export class DialogDeleteDocumentRequirementConfirmation {
    
    public documentRequirementName: string;
    public onDelete: (() => void);

    constructor(private dialogClient: DialogClientService, private notificationClientService: NotificationClientService) { }

    activate(model: { name: string , onDelete: (() => void)}) {
        this.documentRequirementName = model.name;
        this.onDelete = model.onDelete;
    }

    //Cancel
    cancel() {
        this.dialogClient.hide();
    }

    //Remove
    async remove() {
        try {
            if(this.onDelete) await this.onDelete();
            this.notificationClientService.show("Document removed successfully", "", NotificationType.Success);
            this.cancel();
        }
        catch (error) {
            console.error(error);
            this.notificationClientService.show("Error occured", "", NotificationType.Error);
        }
    }
}